import '../App.css';
import React, {useState, useRef, useEffect, useContext} from 'react';
//import * as FlexLayout from "flexlayout-react";
//import {flexlayout_layout} from './flexlayout-layout';
import Editor from "../Editor/Editor";
import {useSessionStorage} from '../hooks/useSessionStorage'
import {ThemeContext} from '../App';
import ThemeToggle from './ThemeToggle';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';


import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';


function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function LayoutEditor() {
  const [toolbarVisible, setToolbarVisible] = useState(true);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const [executionTime, setExecutionTime] = useState(0);
  const [currentTheme, setCurrentTheme] = useContext(ThemeContext);
  const [variables, setVariables] = useState(
    [
      {name:"foo", value:"bar"},
      {name:"var2", value:"2"},
    ]
  )

  const editorRef = useRef(null);

  const [token, setToken] = useSessionStorage('FormulatorToken','');

  const handleEditorDidMount = function(editor, monaco) {
    editorRef.current = editor; 
  }
  
  const onEvaluate = function() {
    var value = editorRef.current.getValue();
    var v = {};
    variables.forEach(e => {
      if(e.name != "")
        v[e.name] = e.value;
    });


    fetch(`${process.env.REACT_APP_API_BASEURL}Evaluate`, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify({'key':token, 'formula': value, 'variables': v})
      })
      .then(res => res.json())
      .then(data => {
          setResult(data.result);
          setExecutionTime(data.executionTime);
          if(data.errors)
            setError(data.errors[0]);
          else
            setError("");
      })
      .catch(error=>{
          alert(error);
      });
  }
  
  const handleEditorValidation = function(markers) {
    // model markers
    markers.forEach(marker => console.log("onValidate:", marker.message));
  }

  const onChangeName = function(e, i)
  {
    var vars = JSON.parse(JSON.stringify(variables));
    vars[i].name = e.target.value;
    setVariables(vars);
  }

  const onChangeValue = function(e, i)
  {
    var vars = JSON.parse(JSON.stringify(variables));
    vars[i].value = e.target.value;
    setVariables(vars);
  }

  const addVariable = function()
  {
    var vars = JSON.parse(JSON.stringify(variables));
    vars.push({name:'', value:''});
    setVariables(vars);
  }

  const deleteVariable = function(i)
  {
    var vars = JSON.parse(JSON.stringify(variables));
    vars.splice(i,1);
    setVariables(vars);
  }
  


  return (
    <>
    {/* <Box width={'100%'} sx={{padding:'20px',paddingTop:'40px'}}> */}
    <Container maxWidth="md" sx={{paddingTop:'20px'}}>
    <Box minHeight={'30vh'} maxHeight="50vh"sx={{overflowY:'auto', overflowX:'hidden'}} >

    {/* <Grid container spacing={0} maxWidth={'md'} sx={{'& .MuiGrid-root': {
              paddingTop: '10px',
            },}}>
        
    </Grid> */}
    
      
      <Grid container spacing={1} maxWidth={'md'} sx={{'& .MuiGrid-root': {
              paddingTop: '5px',
            },}}>
        <Grid item xs={10}>
          <Typography variant="h5" gutterBottom component="div">
            Variables
          </Typography>
        </Grid>
        <Grid item xs={1} sx={{textAlign:'right'}}>
        <Button onClick={addVariable} size="small"><AddIcon/></Button>
        </Grid>

        <Grid item xs={5}>
          Name
        </Grid>
        <Grid item xs={6}>
          Value
        </Grid>
        { variables.map((v, i)=>{
          return <React.Fragment  key={"var_"+i}>
          <Grid item xs={5}>
            <TextField fullWidth size="small" variant="filled" sx={{
              '& .MuiFilledInput-input': {
                paddingTop: '10px',
              },
            }} value={v.name}
            onChange={(e)=>onChangeName(e, i)}
            />
          </Grid>
          <Grid item xs={5} >
          <TextField  fullWidth size="small" variant="filled" sx={{
              '& .MuiFilledInput-input': {
                paddingTop: '10px',
              },
            }} value={v.value}
            onChange={(e)=>onChangeValue(e, i)}
            />
          </Grid>
          <Grid item xs={1}  sx={{textAlign:'right'}}>
          <Button onClick={()=>deleteVariable(i)} size="small"><DeleteIcon/></Button>
          </Grid>
        </React.Fragment>
        })
        }

      </Grid>
    </Box>
    <Box width={'100%'} sx={{marginTop:'10px'}}>
    <Paper sx={{padding:'5px'}}>
    <Editor
      height="25vh"
      theme={currentTheme === "dark" ? 'vs-dark': 'light'}
      defaultLanguage="vb"
      defaultValue={"IF(AND(foo=\"bar\",Date.Now()>\"1 JAN 2020\"),String.ToUpper(foo),\"foobar\")"}
      onValidate={handleEditorValidation}
      options={{minimap:{enabled:false}}}
      onMount={handleEditorDidMount}
    /></Paper>
    </Box>
    <Box width={'100%'}>
    
    <Button fullWidth onClick={onEvaluate} variant="contained" sx={{marginTop:'10px', marginBottom:'10px'}}>Evaluate</Button>
    
    <Paper sx={{padding:'5px'}}>
      {error ?
          <Box sx={{color:'error.dark', fontSize:'0.8rem'}}>Error: {error}</Box>
          : <>
            <Box>Result: <span dangerouslySetInnerHTML={{__html: result.replace(new RegExp(" ", "g"),'&nbsp;')}} /></Box>
            <Box sx={{color:'success.main', fontSize:'0.8rem'}}>Time Taken: {executionTime}ms</Box>
          </>
      }
    </Paper>
    
    </Box>
    </Container>
    {/* </Box> */}
    
    </>
  );
}

export default LayoutEditor;
